module.exports = __webpack_public_path__ + "img/radiateur-test.2a85387b.png";